import React from "react";

const Facebook = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8 13.35H16.05L16.95 9.75H13.8V7.95C13.8 7.023 13.8 6.15 15.6 6.15H16.95V3.126C16.6566 3.0873 15.5487 3 14.3787 3C11.9352 3 10.2 4.4913 10.2 7.23V9.75H7.5V13.35H10.2V21H13.8V13.35Z"
        fill="#FAFAFA"
      />
    </svg>
  );
};

export default Facebook;
